import React from 'react'
import styled from '@emotion/styled'

const Wrapper = styled.div`
	background-color: ${({ theme }) => theme.colors.gray[100]};
	margin: 0 auto 3rem;
	height: fit-content;
	max-width: 400px;
	padding: 2rem;
	width: 100%;

	${({ theme }) => theme.MQ.M} {
		max-width: 100%;
	}

	${({ theme }) => theme.MQ.L} {
		max-width: 280px;
		width: 95%;
	}
`
const CardTitle = styled.div`
	${({ theme }) => theme.fonts.primarySemiBold};
	color: ${({ theme }) => theme.colors.primary};
	font-size: 1.5rem;
	letter-spacing: -0.37px;
	line-height: 35px;
`
const MainContent = styled.div`
	color: ${({ theme }) => theme.colors.gray[500]};
	${({ theme }) => theme.fonts.primaryMedium};
	font-size: 1rem;
	letter-spacing: -0.25px;
	line-height: 25px;
	padding-bottom: 1rem;
	width: 100%;
`

export function OurMission() {
	return (
		<Wrapper>
			<CardTitle>Our Mission</CardTitle>

			<MainContent>
				<p>
					business.com is a comprehensive business resource catering to SMB owners and industry experts. We
					facilitate an exceptional array of services, tools and insights that are proven, relevant, and
					beneficial. At business.com, we genuinely care about providing a service that will help you start
					and grow your business.
				</p>
			</MainContent>
		</Wrapper>
	)
}
